import React from 'react'
import MyTable from '../../../../../../../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import SupplyBillItems from './SupplyBillItems'

const SupplyBillItemTable = ({ checked, setValueForm, setValidate }) => {
  return (
    <MyTable
        head={
            <>
                {/* <TableCell align="center">№</TableCell> */}
                <TableCell align="center">Назва</TableCell>
                <TableCell align="center">К-сть в рахунку</TableCell>
                <TableCell align="center">К-сть загальна</TableCell>
            </>
        }
        body={
            <SupplyBillItems
                // supplyOrderItems={supplyOrderItems}
                checked={checked}
                setValueForm={setValueForm}
                setValidate={setValidate}
            />
        }
        hidePagination={true}
    />
  )
}

export default SupplyBillItemTable